<template>
  <div class="d-flex flex-column align-center flex-md-row justify-md-center mt-1 mb-2" style="overflow: hidden;">
    <v-card
      :min-width="(ehCelular) ? 200 : 115"
      v-for="(t, i) in temposEspera" 
      :key="i" 
      class="mx-1 my-1 mt-sm-0 d-flex flex-column rounded-lg"
      @click="clinicaSelecionada = i;"
    >
      <div 
        class="d-flex justify-center align-center rounded-lg"
        style="background-color: #004e4c"
      >
        <span class="text-center clinica my-2">{{ t.clinica.toUpperCase() }}</span>
      </div>
      <div class="d-flex justify-center pa-2">
        <span 
          v-if="t.tempoEsperaAtual != 'Sem Espera'"
          class="align-self-center tempoEspera"
        >{{ t.tempoEsperaAtual }}</span>
        <span v-else class="semTempoEspera">{{ t.tempoEsperaAtual }}</span>
      </div>
    </v-card>
  </div>
</template>

<script>
  export default {
    name: 'IndicadorCardsDesktop',
    props: {
      temposEspera: { type: Array, required: true },
      ehCelular: { type: Boolean, required: true },
    },
    data: () => ({
      clinicaSelecionada: 0,
    }),
    watch: {
      clinicaSelecionada() {
        this.$emit('clinicaSelecionada', this.clinicaSelecionada);
      }
    },
  }
</script>

<style>
  .v-btn:before {
    opacity: 0 !important;
  }

  .v-ripple__container {
    opacity: 0 !important;
  }
</style>